// extracted by mini-css-extract-plugin
export default {"linksSection":"hJ-z"};